var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 24.25,
    viewBox: "0 0 20.25 24.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping_bag_icon",
    "data-name": "Shopping bag icon",
    transform: "translate(-2609.057 -2828.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M2628.791,2909.263h-3.5a.394.394,0,1,0,0,.788h3.107v16.8h-18.419v-16.8h3.192a.394.394,0,1,0,0-.788h-3.59a.4.4,0,0,0-.4.394v17.584a.4.4,0,0,0,.4.394h19.208a.4.4,0,0,0,.4-.394h0v-17.584A.4.4,0,0,0,2628.791,2909.263Z",
    transform: "translate(0 -75.158)",
    fill: "#221f20",
    stroke: "#221f20",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2721.271,2909.386a.4.4,0,0,0,.4.395h3.493a.395.395,0,1,0,0-.79h-3.493A.4.4,0,0,0,2721.271,2909.386Z",
    transform: "translate(-104.219 -74.896)",
    fill: "#221f20",
    stroke: "#221f20",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2694.554,2828.477a4.3,4.3,0,0,0-4.3,4.3l-.027,4.544a.393.393,0,0,0,.393.393.388.388,0,0,0,.388-.393l.027-4.544a3.515,3.515,0,1,1,7.03,0l-.028,4.544a.393.393,0,1,0,.785,0l.028-4.544A4.3,4.3,0,0,0,2694.554,2828.477Z",
    transform: "translate(-75.34)",
    fill: "#221f20",
    stroke: "#221f20",
    strokeWidth: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.97594308290b8d218bba1a9f3aa45336.svg";
export { ForwardRef as ReactComponent };